export default __webpack_public_path__ + "1866a214844810c6ff7e40d55f8a8552.svg";